import React, { useEffect } from "react";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Bloodtest from "./Bloodtest";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Bloodtestcon() {
  useEffect(() => {
    movetop();
  }, []);
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Bloodtest />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };
  return (
    <>
      <Helmet>
        <title>Blood Test Centre in Vijayanagar</title>
        <meta
          name="description"
          content="We are the best blood test centre in Vijayanagar and Whitefield. If you are looking for this, feel free to contact us today or call us."
        />
        <meta
          name="keywords"
          content="Best Blood Test Centre in Whitefield, Best Blood Test Centre in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestbloodtestinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestbloodtestinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers comprehensive blood test services including routine, specialized, and preventive laboratory tests with accurate results and professional sample collection to support diagnosis and health monitoring.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Routine blood tests",
              "Complete blood count",
              "Lipid profile analysis",
              "Liver and kidney function tests",
              "Blood glucose monitoring",
              "Thyroid profile tests",
              "Specialized hormone and vitamin assays",
            ],
            keywords: [
              "best bloodtest in Immadihalli",
              "best bloodtest in Whitefield",
              "best bloodtest in Bangalore",
              "best bloodtest in Kundalahalli",
              "best bloodtest in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Blood Test Centre in Vijayanagar patients and support them in achieving
        and maintaining optimal health. Contact us as we are the best Blood Test
        Centre in Vijayanagar.
      </h2>
      <Servicebanner name="Blood test" banner={"../photo/dd2.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
                    <Divider />
                  </div>
                  <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Bloodtestcon;
